const getStyles = (theme, isRTL) => ({
  container: {
    padding: "clamp(16px, 3vw, 24px)",
    direction: isRTL ? 'rtl' : 'ltr',
    marginTop: 0,
  },

  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "24px",
    marginTop: -60,
  },

  statCard: {
    background: theme === "light"
      ? "rgba(255, 255, 255, 1)"
      : "rgba(255, 255, 255, 0.01)",
    backdropFilter: "blur(20px)",
    border: theme === "light"
      ? "1px solid rgba(0, 0, 0, 0.1)"
      : "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "16px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    direction: isRTL ? 'rtl' : 'ltr',
    flexDirection: isRTL ? 'row-reverse' : 'row',
  },

  statIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // Was a self-gradient (both stops the same blue) -- every other stat
    // icon uses two distinct shades for the gradient effect, this one just
    // rendered flat by mistake.
    background: "linear-gradient(135deg, #2e7cba, #25638f)",
    flexShrink: 0,
  },

  statInfo: {
    flex: 1,
    textAlign: isRTL ? 'right' : 'left',
  },

  statValue: {
    fontSize: "24px",
    fontWeight: "700",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    margin: "0",
  },

  statLabel: {
    fontSize: "14px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.7)",
    margin: "4px 0 0 0",
  },

  card: {
    background: theme === "light"
      ? "rgba(255, 255, 255, 1)"
      : "rgba(255, 255, 255, 0.01)",
    backdropFilter: "blur(20px)",
    border: theme === "light"
      ? "1px solid rgba(0, 0, 0, 0.1)"
      : "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "16px",
    padding: "24px",
    direction: isRTL ? 'rtl' : 'ltr',
  },

  title: {
    fontSize: "24px",
    fontWeight: "700",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    margin: "0 0 24px 0",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexDirection: isRTL ? 'row' : 'row',
  },

  tabContainer: {
    display: "flex",
    gap: "8px",
    marginBottom: "24px",
    borderBottom: theme === "light"
      ? "2px solid #e2e8f0"
      : "2px solid rgba(255, 255, 255, 0.1)",
    paddingBottom: "0",
    overflowX: "auto",
    flexDirection: isRTL ? 'row' : 'row',
  },

  tab: (isActive) => ({
    padding: "12px 24px",
    border: "none",
    background: "transparent",
    color: isActive
      ? (theme === "light" ? "#2e7cba" : "#60a5fa")
      : (theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)"),
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    borderBottom: isActive ? "3px solid #2e7cba" : "none",
    marginBottom: "2px",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
  }),

  requestCard: {
    padding: "20px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
    border: theme === "light"
      ? "2px solid #e2e8f0"
      : "2px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "12px",
    marginBottom: "16px",
    background: theme === "light"
      ? "#ffffff"
      : "rgba(255, 255, 255, 0.02)",
    transition: "all 0.3s ease",
    direction: isRTL ? 'rtl' : 'ltr',
  },

  requestHeader: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "16px",
    flexDirection: isRTL ? 'row' : 'row',
  },

  requestInfo: {
    flex: 1,
    minWidth: "250px",
    textAlign: isRTL ? 'right' : 'left',
  },

  employeeName: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    margin: "0 0 8px 0",
  },

  requestDetail: {
    fontSize: "14px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.7)",
    margin: "6px 0",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexDirection: isRTL ? 'row' : 'row',
  },

  statusBadge: (status) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    background:
      status === 'approved' ? 'rgba(16, 185, 129, 0.1)' :
        status === 'rejected' ? 'rgba(239, 68, 68, 0.1)' :
          status === 'disbursed' ? 'rgba(59, 130, 246, 0.1)' :
            status === 'completed' ? 'rgba(139, 92, 246, 0.1)' :
              'rgba(245, 158, 11, 0.1)',
    color:
      status === 'approved' ? '#10b981' :
        status === 'rejected' ? '#ef4444' :
          status === 'disbursed' ? '#2e7cba' :
            status === 'completed' ? '#8b5cf6' :
              '#f59e0b',
    flexDirection: isRTL ? 'row' : 'row',
  }),

  buttonGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    flexDirection: isRTL ? 'row' : 'row',
  },

  button: {
    // Same self-gradient mistake as statIcon above -- both stops were
    // identical, so the primary action button (Approve/Process/Disburse)
    // rendered as a flat fill instead of the intended gradient, unlike the
    // reject button below which correctly uses two shades.
    background: "linear-gradient(135deg, #2e7cba, #25638f)",
    color: "white",
    border: "none",
    borderRadius: "10px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexDirection: isRTL ? 'row-reverse' : 'row',
  },

  secondaryButton: {
    background: theme === "light"
      ? "rgba(0, 0, 0, 0.05)"
      : "rgba(255, 255, 255, 0.1)",
    color: theme === "light" ? "#374151" : "#ffffff",
    border: "none",
    borderRadius: "10px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexDirection: isRTL ? 'row-reverse' : 'row',
  },

  rejectButton: {
    background: "linear-gradient(135deg, #ef4444, #dc2626)",
    color: "white",
    border: "none",
    borderRadius: "10px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexDirection: isRTL ? 'row-reverse' : 'row',
  },

  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
  },

  errorState: {
    textAlign: "center",
    padding: "60px 20px",
    color: "#ef4444",
  },

  loadingState: {
    textAlign: "center",
    padding: "60px 20px",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
  },

  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    // hide scrollbar but keep scrolling
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE / Edge
    WebkitOverflowScrolling: "touch", // iOS
    padding: "20px",
  },

  modalContent: {
    background: theme === "light"
      ? "rgba(255, 255, 255, 0.95)"
      : "rgba(30, 41, 59, 0.95)",
    padding: "32px",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "600px",
    maxHeight: "85vh",
    overflowY: "auto",
    boxShadow: theme === "light"
      ? "0 10px 40px rgba(0, 0, 0, 0.15)"
      : "0 10px 40px rgba(0, 0, 0, 0.5)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    direction: isRTL ? 'rtl' : 'ltr',
    // hide scrollbar but keep scrolling
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE / Edge
    WebkitOverflowScrolling: "touch", // iOS
  },

  modalTitle: {
    fontSize: "20px",
    fontWeight: "700",
    marginBottom: "24px",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    textAlign: isRTL ? 'right' : 'left',
  },

  formGroup: {
    marginBottom: "20px",
  },

  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "8px",
    color: theme === "light" ? "#374151" : "rgba(255, 255, 255, 0.9)",
    textAlign: isRTL ? 'right' : 'left',
  },

  textarea: {
    width: "100%",
    minHeight: "100px",
    padding: "12px",
    border: theme === "light"
      ? "2px solid #e2e8f0"
      : "2px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "12px",
    background: theme === "light" ? "#f8fafc" : "rgba(255, 255, 255, 0.05)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: "14px",
    fontFamily: "inherit",
    resize: "vertical",
    outline: "none",
    transition: "border-color 0.3s ease",
    boxSizing: "border-box",
    direction: isRTL ? 'rtl' : 'ltr',
    textAlign: isRTL ? 'right' : 'left',
  },

  input: {
    width: "100%",
    padding: "12px",
    border: theme === "light"
      ? "2px solid #e2e8f0"
      : "2px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "12px",
    background: theme === "light" ? "#f8fafc" : "rgba(255, 255, 255, 0.05)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: "14px",
    fontFamily: "inherit",
    outline: "none",
    transition: "border-color 0.3s ease",
    boxSizing: "border-box",
    direction: isRTL ? 'rtl' : 'ltr',
    textAlign: isRTL ? 'right' : 'left',
  },

  select: {
    width: "100%",
    padding: "12px",
    border: theme === "light"
      ? "2px solid #e2e8f0"
      : "2px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "12px",
    background: theme === "light" ? "#f8fafc" : "rgba(255, 255, 255, 0.05)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: "14px",
    fontFamily: "inherit",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    outline: "none",
    cursor: "pointer",
    boxSizing: "border-box",
    direction: isRTL ? 'rtl' : 'ltr',
  },

  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 0",
    borderBottom: theme === "light"
      ? "1px solid #e2e8f0"
      : "1px solid rgba(255, 255, 255, 0.1)",
    flexDirection: 'row',
  },

  detailLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.7)",
    textAlign: isRTL ? 'right' : 'left',
  },

  detailValue: {
    fontSize: "14px",
    fontWeight: "500",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    textAlign: isRTL ? 'left' : 'right',
  },
});

export default getStyles;